import { FC } from 'react';
import cn from 'classnames';

import type { SectionComponentInterface } from 'types/componentTypes';
import classes from 'src/styles/_commonClasses.module.scss';
import { capitalizeFirstLetter } from 'lib/text.service';
import { CommonSize } from 'constants/enums';
import { CommonRichText } from 'components/Shared/SharedComponents';
import { MultiCarousel as Carousel } from 'components/dynamic';
import { Block } from 'src/__generated__/graphqlTypes';

import styles from './MultipleItemsSlider.module.scss';
import Item from './Item';
import { Dot } from './Dot';

const MultipleItemsSlider: FC<SectionComponentInterface> = ({
  blocks,
  bgColor,
  extraData,
}) => {
  const {
    verticalMargin = CommonSize.SMALL,
    verticalPadding = CommonSize.SMALL,
    autoPlaySpeedSeconds,
  } = extraData || {};
  const [block] = blocks;
  const autoPlaySpeed = autoPlaySpeedSeconds ? autoPlaySpeedSeconds * 1000 : undefined;

  if (!block) {
    return null;
  }

  const contentItems = block.contentTypesCollection?.items as Array<Block>;

  if (!contentItems) {
    return null;
  }

  const autoplayProps = autoPlaySpeed
    ? {
      autoPlay: true,
      infinite: true,
      autoPlaySpeed,
    }
    : {
      autoPlay: false,
      autoPlaySpeed: Infinity,
    };

  return (
    <section
      className={cn(
        styles.wrapper,
        classes[`marginVertical${capitalizeFirstLetter(verticalMargin)}`],
        verticalPadding && classes[`sharedWrapperPaddingVertical${capitalizeFirstLetter(verticalPadding)}`],
      )}
      style={{ background: bgColor }}
    >
      <CommonRichText content={block.richTitle} parsersConfig={{}} />
      <CommonRichText content={block.content} parsersConfig={{}} />
      <Carousel
        arrows={false}
        customDot={<Dot autoPlaySpeed={autoPlaySpeed} />}
        {...autoplayProps}
        shouldResetAutoplay={false}
        ssr
        swipeable
        pauseOnHover
        showDots
        dotListClass={styles.dots}
        itemClass={styles.item}
        responsive={{
          any: {
            breakpoint: { max: 4000, min: 0 },
            items: 1,
            slidesToSlide: 1,
          },
        }}
        className={styles.carousel}
      >
        {contentItems.map((item) => <Item key={item.sys.id} item={item} />)}
      </Carousel>
    </section>
  );
};

export default MultipleItemsSlider;
